import { Component, computed, input, Optional, output, Self, signal } from '@angular/core';
import { ControlValueAccessor, FormsModule, NgControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-search-input',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
  ],
  templateUrl: './search-input.component.html',
  styleUrl: './search-input.component.scss',
})
export class SearchInputComponent implements ControlValueAccessor {
  placeholder = input<string>('Search for topics, meetings etc.');
  type = input<string>('text');
  isCross = input<boolean>(false);
  buttonOrEnterClicked = output<boolean>();
  emitCloseSearch = output<boolean>();

  theme = input<'white' | 'dark'>('dark');
  isWhiteTheme = computed(() => this.theme() === 'white');
  searchTextValue = signal('');


  value: string = '';
  touched = false;
  disabled = false;
  errors = [];

  constructor(@Self() @Optional() protected control: NgControl) {
    if (control) {
      control.valueAccessor = this;
    }
  }

  inputHandler($event: Event): void {
    const inputValue = ($event.target as HTMLInputElement).value;
    this.searchTextValue.set(inputValue || '');
    this.touched = true;

    this.onChange(inputValue);
    this.onTouch();
  }

  onChange: any = () => {
  };
  onTouch: any = () => {
  };

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  emitBtnEvent() {
    this.buttonOrEnterClicked.emit(true);
  }

  closeSearch(): void {
    this.emitCloseSearch.emit(true);
    this.value = '';

    if (this.isWhiteTheme()) {
      this.searchTextValue.set('');
      this.onChange('');
      this.onTouch();
    }

  }

}
